module.exports = __webpack_public_path__ + "static/media/img189.4599d863.jpg";